import TabContext from "@mui/lab/TabContext";
import { Avatar, Box, List, ListItem, Menu, Typography } from "@mui/material";
import Tab from "@mui/material/Tab";
import * as React from "react";
import { useLocation } from "react-router-dom";
import AddUsersIco from "../../../../assets/icons/AddUsersIco";
import DocIco from "../../../../assets/icons/DocIco";
import FavouriteIco from "../../../../assets/icons/FavouriteIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import {
  CommonGrid2,
  TabPanelView,
  TabViewSection,
} from "../../../common-components/StyledComponents";
import JobsCandidate from "../jobs-candidate";
import JobsSummary from "../jobs-summary";
import AddMoreCandidate from "../../quick-match/components/AddMoreCandidate";
import AddUpdateNote from "../../../common-components/AddUpdateNote";
import { CustomDiv } from "../../../chat-bot/style";

export default function AccessTeamFitView() {
  const query = new URLSearchParams(useLocation().search);
  const jobId = query.get("id");
  const [value, setValue] = React.useState("0");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeTabs, setActiveTabs] = React.useState([0, 1, 2]); // First 3 highest scores by default
  const open = Boolean(anchorEl);
  const [addMoreCandidateDialogOpen, setAddMoreCandidateDialogOpen] =
    React.useState(false);
  const [addMoreCandidateFiles, setAddMoreCandidateFiles] = React.useState([]);
  const [isClicked, setIsClicked] = React.useState(false);
  const [openNoteDialog, setOpenNoteDialog] = React.useState(false);
  const [noteList, setNoteList] = React.useState([
    { note: "", interaction: "Email", added_by: "username" },
  ]);

  const resumeTab = [
    { id: 1, name: "Zahir Mays", score: 95, file_name: "Resume_One.pdf" },
    { id: 3, name: "Phoenix Baker", score: 79, file_name: "Resume_Two.pdf" },
    { id: 4, name: "Lana Steiner", score: 80, file_name: "Resume_Two.pdf" },
    { id: 2, name: "Jacob Jones", score: 60, file_name: "Resume_Two.pdf" },
    { id: 5, name: "Jane Cooper", score: 75, file_name: "Resume_Two.pdf" },
    { id: 6, name: "Mathew", score: 65, file_name: "Resume_Two.pdf" },
    { id: 7, name: "Robert Fox", score: 60, file_name: "Resume_Two.pdf" },
    { id: 8, name: "Jenny Wilson", score: 55, file_name: "Resume_Two.pdf" },
    { id: 9, name: "Brooklyn Simson", score: 50, file_name: "Resume_Two.pdf" },
    { id: 10, name: "Olivia", score: 45, file_name: "Resume_Two.pdf" },
  ];

  // Sort resumes by score descending
  const sortedResumeTab = React.useMemo(() => {
    return [...resumeTab].sort((a, b) => b.score - a.score);
  }, [resumeTab]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleAddTab = (index) => {
    setActiveTabs((prev) => [...prev, index]);
    setValue((index + 2).toString());
    handleMenuClose();
  };

  const menuItems = resumeTab.slice(3).map((item, index) => ({
    ...item,
    isEnabled: index, // Enable only the 4th highest score
  }));

  const allowedTypes = [
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const commonFileValidationCheck = (
    commonFiles,
    allowedTypes,
    setCommonFiles,
    existingFiles
  ) => {
    const validFiles = [];
    const invalidFiles = [];

    commonFiles.forEach((file) => {
      if (allowedTypes.includes(file.type)) {
        validFiles.push({
          file,
          name: file.name,
          size: `${(file.size / 1024).toFixed(1)} KB`,
          type: file.type,
          progress: 0,
          buffer: 0,
          visible: false,
          delete: true,
          message: "",
        });
      } else {
        invalidFiles.push(file.name);
      }
    });

    const mergedFiles = [
      ...existingFiles,
      ...validFiles.filter(
        (newFile) =>
          !existingFiles.some(
            (existingFile) => existingFile.name === newFile.name
          )
      ),
    ];
    setCommonFiles(mergedFiles);

    if (invalidFiles.length > 0) {
    }
  };

  const handleAddCandidateClick = () => {
    setAddMoreCandidateDialogOpen(true);
  };

  const handleAddMoreCandidateFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    commonFileValidationCheck(
      selectedFiles,
      allowedTypes,
      setAddMoreCandidateFiles,
      addMoreCandidateFiles
    );
  };

  const handleButtonClick = () => {
    setIsClicked(!isClicked);
  };

  const handleAddNote = () => {
    setOpenNoteDialog(true);
  };

  const handleCloseNoteDialog = () => {
    setOpenNoteDialog(false);
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleNoteTextChange = (index, e) => {
    const newNoteList = [...noteList];
    newNoteList[index].note = e.target.value;
    setNoteList(newNoteList);
  };

  return (
    <CustomDiv background="#F6F8FB">
      <CustomDiv
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
      >
        <Breadcrumbs
          breadCrumbData={[
            { title: "jigsaw", navigate: "/access-team-fit" },
            { title: query.get("title"), active: true },
          ]}
        />
        <TabContext value={value}>
          <CommonGrid2
            container
            spacing={2}
            alignItems="center"
            marginTop={2.5}
          >
            <CommonGrid2 item size={{ xs: 12, md: 9, sm: 8 }}>
              <TabViewSection onChange={handleChange}>
                <Tab label="Fit Analysis" value="0" />
                {activeTabs.map((index) => (
                  <Tab
                    label={`#${index + 1} ${resumeTab[index].name} - ${
                      resumeTab[index].score
                    }%`}
                    value={(index + 2).toString()}
                    key={index}
                  />
                ))}
              </TabViewSection>
            </CommonGrid2>
            <CommonGrid2
              item
              size={{ xs: 12, md: 3, sm: 4 }}
              gap="1rem"
              display={"flex"}
              justifyContent="end"
            >
              <CommonButton
                color="#344054"
                fontWeight="600"
                value={<AddUsersIco />}
                padding="14px 12px"
                onClick={handleAddCandidateClick}
              />
              <CommonButton
                color="#344054"
                border="#D0D5DD"
                fontWeight="600"
                value={
                  <FavouriteIco color={isClicked ? "#7F56D9" : "#eaecf0"} />
                } // Pass color based on state
                padding="14px 12px"
                onClick={handleButtonClick}
              />

              {value === "0" ? null : (
                <CommonButton
                  color="#344054"
                  border="#D0D5DD"
                  fontWeight="600"
                  value={<DocIco />}
                  padding="14px 12px"
                  onClick={handleAddNote}
                />
              )}
            </CommonGrid2>
          </CommonGrid2>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                width: 350,
                borderRadius: 2,
                padding: 1,
              },
            }}
          >
            <List sx={{ padding: 0 }}>
              {menuItems.map((item, index) => (
                <ListItem
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingY: 1.5,
                    "&:not(:last-child)": {
                      borderBottom: "1px solid #E0E0E0",
                    },
                  }}
                  onClick={() => item.isEnabled && handleAddTab(index + 3)}
                  disabled={!item.isEnabled}
                >
                  {/* Left: Avatar and Name */}
                  <Box display="flex" alignItems="center" gap={1.5}>
                    <Avatar alt={item.name} sx={{ width: 40, height: 40 }}>
                      {item.name[0]}
                    </Avatar>
                    <Typography fontSize={16} fontWeight={600} color="#344054">
                      {item.name}
                    </Typography>
                  </Box>

                  {/* Right: Score */}
                  <Box
                    sx={{
                      background: item.isEnabled ? "#F2F4F7" : "#E0E0E0",
                      borderRadius: "12px",
                      paddingX: 1.5,
                      paddingY: 0.5,
                    }}
                  >
                    <Typography fontSize={14} fontWeight={600} color="#344054">
                      {item.score}%
                    </Typography>
                  </Box>
                </ListItem>
              ))}
            </List>
          </Menu>
          <TabPanelView value="0" padding="24px 0px">
            <JobsSummary />
          </TabPanelView>
          {activeTabs.map((index) => (
            <TabPanelView
              value={(index + 2).toString()}
              key={index}
              padding="24px 0px"
            >
              <JobsCandidate candidate={resumeTab[index]} />
            </TabPanelView>
          ))}
        </TabContext>

        <AddMoreCandidate
          addMoreCandidateDialogOpen={addMoreCandidateDialogOpen}
          handleAddMoreCandidateDialogClose={() =>
            setAddMoreCandidateDialogOpen(false)
          }
          handleAddMoreCandidateClick={() =>
            setAddMoreCandidateDialogOpen(false)
          }
          handleAddMoreCandidateFileUpload={handleAddMoreCandidateFileUpload}
        />

        <AddUpdateNote
          openNoteDialog={openNoteDialog}
          handleCloseNoteDialog={handleCloseNoteDialog}
          // id={noteId}
          handleCreateNote={handleCloseNoteDialog}
          noteList={noteList}
          handleNoteTextChange={handleNoteTextChange}
        />
      </CustomDiv>
    </CustomDiv>
  );
}
